export default __webpack_public_path__ + "static/media/scroll-up.68a86b53.svg";